/* @flow */

import React from 'react'

/*
 * a generic component that displays its children conditionally
 */
export default function Condition(props: {
  shouldRender: boolean,
  className?: string,
  children?: React$Node,
}) {
  if (props.shouldRender) {
    if (React.Children.count(props.children) === 1) {
      // we can/should omit the wrapping div if there's only one child
      return props.children
    }
    return <div className={props.className}>{props.children}</div>
  }
  return null
}



// WEBPACK FOOTER //
// ./src/components/Condition.js